import { cartLineKey } from '../cart/cartUtils';
import { productCharPersonalizationEnabled, productTextPersonalizationAtCheckout } from '../productPersonalization';

/** Free-text personalization fields shown at checkout (not letter-picker products). */
export function textPersonalizationFields(lines, productsByCategory) {
  const out = [];
  for (const line of lines || []) {
    const list = productsByCategory?.[line.categorySlug] || [];
    const p = list.find((x) => String(x.id) === String(line.productId));
    if (!p) continue;
    if (productCharPersonalizationEnabled(p)) continue;
    if (productTextPersonalizationAtCheckout(p)) {
      out.push({
        line,
        key: cartLineKey(line.categorySlug, line.productId, line.customization),
      });
    }
  }
  return out;
}

/** @deprecated use textPersonalizationFields */
export function personalizedLines(lines, productsByCategory) {
  return textPersonalizationFields(lines, productsByCategory);
}
